export enum ContractStateEnum {
  CONTRACT_ACTIVE = 'CONTRACT_ACTIVE',
  CONTRACT_EXPIRED = 'CONTRACT_EXPIRED',
  CONTRACT_CLOSED = 'CONTRACT_CLOSED'
}
